import { Component, OnInit } from '@angular/core';
import {FwdRemarkComponent} from '../../approval-process/fwd-remark/fwd-remark.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ApprovalModel} from '../../shared/dto/approval.model';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {UserRoleEnum} from '../../shared/enums/user-role.enum';
import {ReturnRemarkComponent} from '../../approval-process/return-remark/return-remark.component';
import {RemarkComponent} from '../../approval-process/remark/remark.component';
import {ApprovalService} from '../../service/approval.service';
import {ActivatedRoute} from '@angular/router';
import {BlacklistDocumentModel} from '../../shared/dto/blacklist-document.model';
import {BlacklistService} from '../../shared/service/blacklist.service';
import {BlacklistApproveChecklistComponent} from '../blacklist-approve-checklist/blacklist-approve-checklist.component';
import {WorkflowEnum} from '../../shared/enums/workflow.enum';

@Component({
  selector: 'app-blacklist-process-request-viewer',
  templateUrl: './blacklist-process-request-viewer.component.html',
  styleUrls: ['./blacklist-process-request-viewer.component.scss']
})
export class BlacklistProcessRequestViewerComponent implements OnInit {
  appRefNo: number;
  userName: string;
  userRole: string;
  type: string;
  types: string;
  DG:string = UserRoleEnum.DG;
  SHO:string = UserRoleEnum.SHO;
  EXM:string = UserRoleEnum.EXM;
  currentStage: string = WorkflowEnum.BLACKLIST;
  approvalModel: ApprovalModel = new ApprovalModel();
  showDiv1: boolean = false;
  showDiv2: boolean = false;

  constructor(private route: ActivatedRoute,
              private tokenStorageService: TokenStorageService,
              private approvalService: ApprovalService,
              private modalService: NgbModal,
              private blackListService: BlacklistService) {

      this.route.paramMap.subscribe(params => {
      this.appRefNo = +this.decodeBase64(params.get('id'));
      this.types = this.decodeBase64(params.get('types'));

      if(this.types === "blacklist"){
        this.showDiv1 = true;
        this.showDiv2 = false;
      }else if(this.types === "suspend") {
        this.showDiv2 = true;
        this.showDiv1 = false;
      }
    });
  }

  ngOnInit() {
    this.userName=this.tokenStorageService.getUserObjectToken().username;
    this.userRole=this.tokenStorageService.getUserObjectToken().userroleCode;
  }
  decodeBase64(code: string): string {
    return atob(code);
  }

  rejectRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'Reject';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(RemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
      appType: this.types
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService)
  }

  returnRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'RETURN';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(ReturnRemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
      appType: this.types
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  approveRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'APPROVE';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;
    this.approvalModel.stage = WorkflowEnum.BLACKLIST;

    const modalRef = this.modalService.open(BlacklistApproveChecklistComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
      appType: this.types
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }
}
